// This file replaces legacy/media/scripts/site/Utilities.js

// Add functions from the old file as required

// Convert duration (in seconds) to a more readable 'X days, Y hours, Z mins, N mins'
export const formatDuration = function (duration) {
  // Caps out at days because months becomes variable
  var day = 86400; // 60 * 60 * 24
  var hour = 3600; // 60 * 60
  var min = 60; // 60s in a minute
  var data = {
    day: 0,
    hour: 0,
    min: 0,
    sec: 0,
  };
  var bits = [];
  var temp = duration;

  if (temp >= day) {
    data.day = parseInt(temp / day, 10);
    temp = temp % day;
  }

  if (temp >= hour) {
    data.hour = parseInt(temp / hour, 10);
    temp = temp % hour;
  }

  if (temp >= min) {
    data.min = parseInt(temp / min, 10);
    temp = temp % min;
  }

  data.sec = temp;

  // Put it together
  ['day', 'hour', 'min', 'sec'].forEach(function (timescale) {
    var value = data[timescale];

    if (value) {
      bits.push(
        value !== 1 ? value + ' ' + timescale + 's' : value + ' ' + timescale
      );
    }
  });

  return bits.join(' ');
};

// Converts an iso-format timestamp to 01 January 2000, 01:00:00
export const formatTimestamp = function (isoTimestamp, format) {
  if (format === undefined) {
    format = '%a, %d %b %Y %I:%M%p';
  }

  var t =
    typeof isoTimestamp === 'string'
      ? this.parseISODate(isoTimestamp)
      : isoTimestamp;

  // JAVASCRIPT Y U NO HAVE FORMAT STRINGS?!
  var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  // I can't believe I have to do this
  var month = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  var fullMonth = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  var weekdays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  var meridiem = 'am';
  var hours = t.getHours();
  var hours24 = t.getHours();

  if (hours > 11) {
    hours -= 12;
    meridiem = 'pm';
  }

  if (hours === 0) {
    hours = 12;
  }

  var formattedTimestamp = format
    .replace(/%a/g, day[t.getDay()])
    .replace(/%A/g, weekdays[t.getDay()])
    .replace(/%d/g, this.zfill(t.getDate(), 2))
    .replace(/%D/g, t.getDate())
    .replace(/%b/g, month[t.getMonth()])
    .replace(/%B/g, fullMonth[t.getMonth()])
    .replace(/%Y/g, t.getFullYear())
    .replace(/%I/g, this.zfill(hours, 2))
    .replace(/%H/g, this.zfill(hours24, 2))
    .replace(/%M/g, this.zfill(t.getMinutes(), 2))
    .replace(/%S/g, this.zfill(t.getSeconds(), 2))
    .replace(/%p/g, meridiem)
    .replace(/%P/g, meridiem.toUpperCase());
  return formattedTimestamp;
};

export const getCookie = function (name, defaultValue) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) == name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }

  if (typeof defaultValue !== 'undefined' && cookieValue === null) {
    cookieValue = defaultValue;
  }

  return cookieValue;
};

export const parseISODate = function (isoString) {
  return new Date(isoString);
};

export const parseURL = function (url) {
  var link = document.createElement('a');
  link.href = url;
  return link;
};

export const sameOrigin = function (url1, url2) {
  // same origin has same host (hostname + port) & protocol
  var a = this.parseURL(url1);
  var b = this.parseURL(url2);
  return a.protocol === b.protocol && a.host === b.host;
};

export const capitalise = function (source) {
  return source.charAt(0).toUpperCase() + source.slice(1);
};

// pads a string with 0
export const zfill = function (number, length) {
  var str = '' + number;
  while (str.length < length) {
    str = '0' + str;
  }

  return str;
};

export const getFileExtension = function (filename) {
  var index = filename.lastIndexOf('.');
  var ext = '';
  if (index != -1) {
    ext = filename.substr(index);
  }
  return ext;
};

// From http://snipplr.com/view/5945/javascript-numberformat--ported-from-php/
// and http://snipplr.com/view/5949/
export const size_format = function (filesize) {
  if (filesize >= 1099511627776) {
    filesize = this.number_format(filesize / 1099511627776, 2, '.', '') + ' TB';
  } else if (filesize >= 1073741824) {
    filesize = this.number_format(filesize / 1073741824, 2, '.', '') + ' GB';
  } else if (filesize >= 1048576) {
    filesize = this.number_format(filesize / 1048576, 2, '.', '') + ' MB';
  } else if (filesize >= 1024) {
    filesize = this.number_format(filesize / 1024, 0) + ' KB';
  } else {
    filesize = this.number_format(filesize, 0) + ' bytes';
  }
  return filesize;
};

export const number_format = function (
  number,
  decimals,
  dec_point,
  thousands_sep
) {
  var n = number,
    c = isNaN((decimals = Math.abs(decimals))) ? 2 : decimals;
  var d = dec_point === undefined ? ',' : dec_point;
  var t = thousands_sep === undefined ? '.' : thousands_sep,
    s = n < 0 ? '-' : '';
  var i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + '',
    j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : '')
  );
};
